<template>
  <div class="box">
    <div class="header">
      <div class="heng mr10"></div>
      <div class="mr10">{{ headerConfig.title }}</div>
      <div
        v-if="headerConfig.time"
        class="mr10 text-muted"
        style="font-size: 14px"
      >
        更新时间: {{ new Date().Format('yyyy-MM-dd hh:mm:ss') }}
      </div>
      <div
        v-if="headerConfig.text"
        class="mr10 text-muted"
        style="font-size: 12px"
      >
        {{ headerConfig.text }}
      </div>
      <el-popover
        v-if="headerConfig.totalConfig"
        style="flex: 1"
        placement="top-start"
        title="说明"
        trigger="hover"
      >
        <div class="totalConfig mb10" v-html="headerConfig.totalConfig"></div>
        <div
          slot="reference"
          class="mt5 info el-icon-question"
          style="flex: 1; color: #8a8a8a"
        ></div>
      </el-popover>
      <div v-else style="flex: 1"></div>
      <el-button type="text" @click="handleRightButtonClick">
        {{ headerConfig.rightBtnText }}
      </el-button>
      <el-date-picker
        v-if="timeShow"
        v-model="value1"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />
      <div v-if="tabsShow" class="tabs">
        <div
          v-for="(item, index) of itemData"
          :key="index"
          class="tabs-item"
          :class="{ tabsActive: currentIndex == item.code }"
          @click="handelEcharts(item.code)"
        >
          {{ item.desc }}
        </div>
      </div>

      <div v-if="exportShow" class="tabs">
        <el-dropdown style="cursor: pointer" @command="handleCommand($event)">
          <span class="el-dropdown-link">
            <i
              style="font-size: 20px"
              class="mt10 mb10 ml10 el-icon-s-operation"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>导出excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      // 控制时间搜索框
      timeShow: {
        type: Boolean,
        default: false,
      },
      // 控制tab选择框
      tabsShow: {
        type: Boolean,
        default: false,
      },
      exportShow: {
        type: Boolean,
        default: false,
      },
      headerParams: {
        type: Object,
        default: () => {
          return {}
        },
      },
      exportUrl: {
        type: Function,
        default: () => {
          function counter() {
            //嵌套函数
          }
          return counter
        },
      },

      // 头部说明及头部title
      headerConfig: {
        type: Object,
        default: () => {
          return {
            title: '概况',
            totalConfig: [],
          }
        },
      },
      // 按钮切换数据
      itemData: {
        type: Array,
        default: () => {
          return [
            { desc: '分时段', code: 1 },
            { desc: '累计', code: 2 },
          ]
        },
      },
    },
    data() {
      return {
        value1: '',
        currentIndex: 1,
      }
    },
    methods: {
      handelEcharts(code) {
        this.currentIndex = code
        this.$emit('selectTabs', code)
      },
      handleRightButtonClick() {
        this.$emit('rightButtonClick')
      },
      handleCommand() {
        let params = Object.assign(this.headerParams, {
          pageNum: undefined,
          pageSize: undefined,
        })
        this.download(this.exportUrl(), params, '导出excel')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .box {
    margin: 0px 0px 10px 0px;
    padding: 10px;
    background: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      font-size: 16px;
      border-bottom: 1px solid #e4e4e4;
      padding-bottom: 10px;
      margin-bottom: 10px;
      height: 36px;
      .heng {
        height: 16px;
        width: 3px;
        background: #2589ff;
      }
      .info {
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  .totalConfig {
    max-height: 600px;
    overflow-y: auto;
    display: flex;
    .totalConfig_title {
      font-weight: bold;
    }
    .totalConfig_text {
      color: #acacac;
      flex: 1;
    }
  }

  .tabs {
    margin-left: 20px;
    display: flex;
    overflow-x: auto; /* 横向滚动 */
    max-width: 600px; /* 可根据实际页面调整宽度 */
    white-space: nowrap; /* 防止换行 */
    .tabs-item {
      display: flex;
      margin: 0 5px;
      color: #aaa;
      font-size: 12px;
      cursor: pointer;
      padding: 5px 10px;
      border: 1px solid #aaa;
      border-radius: 4px;
    }
  }
  .tabsActive {
    color: #fff !important;
    border: 1px solid #2589ff !important;
    border-radius: 4px;
    background: #2589ff;
  }
</style>
